import { normalizeLocale } from "@/utils/locale";

const CURRENCY_SYMBOL_MAP = {
  CNY: "￥",
  HKD: "HK$",
  USD: "$",
  JPY: "￥",
  TWD: "NT$",
};

const FOREIGN_CURRENCY_SYMBOL_MAP = {
  CNY: "CN￥",
  HKD: "HK$",
  USD: "US$",
  JPY: "JP￥",
  TWD: "TW$",
};

const LOCAL_CURRENCY_BY_LOCALE = {
  "en-us": "USD",
  "zh-cn": "CNY",
  "zh-hk": "HKD",
  "zh-mo": "CNY",
  "zh-tw": "TWD",
  "ja-jp": "JPY",
};

function normalizeCurrency(currencyCode) {
  if (!currencyCode) {
    return "CNY";
  }
  return String(currencyCode).trim().toUpperCase();
}

function getBaseCurrencySymbol(i18n, currencyCode) {
  const normalizedCurrency = normalizeCurrency(currencyCode);

  if (i18n && typeof i18n.te === "function" && i18n.te(normalizedCurrency)) {
    return i18n.t(normalizedCurrency);
  }

  return CURRENCY_SYMBOL_MAP[normalizedCurrency] || CURRENCY_SYMBOL_MAP.CNY;
}

function getCurrencySymbol(i18n, currencyCode) {
  const normalizedCurrency = normalizeCurrency(currencyCode);
  const locale = normalizeLocale(i18n && i18n.locale);
  const localCurrency = LOCAL_CURRENCY_BY_LOCALE[locale] || "CNY";

  if (normalizedCurrency === localCurrency) {
    return getBaseCurrencySymbol(i18n, normalizedCurrency);
  }

  return (
    FOREIGN_CURRENCY_SYMBOL_MAP[normalizedCurrency] ||
    `${normalizedCurrency}${getBaseCurrencySymbol(i18n, normalizedCurrency)}`
  );
}

export { normalizeCurrency, getCurrencySymbol };
